<div class="auth-container" style="background: none; height: 95vh; overflow: auto;">
    <app-toolbar></app-toolbar>
    <div class="container">
        <div class="container-title">
            <span class="terms-title">
                Términos y condiciones de uso
            </span>
        </div>

        <div class="bloque1">
            <p class="textBloque1">
                Estos términos y condiciones de uso, incluyendo sus anexos (las “Condiciones Generales”),constituyen un
                contrato
                (El “Contrato” o “Acuerdo”) entre cualquier persona (en adelante, el “Usuario” o, en plural, “Usuarios”)
                que desee
                acceder y/o usar los servicios de Yacaré ofrecidos mediante la aplicación móvil denominada “Yacaré” (en
                adelante, la “App”)
                o su sitio web (el “Sitio” y junto con la App, la “Plataforma”) de Orangedata S.A., <br>CUIT
                30-71239031-6 (en adelante, “Yacaré”)
                domiciliada en Avenida Belgrano 312, Piso 1, Oficina 11,Ciudad Autónoma de Buenos Aires, en su carácter
                de gestor,
                administrador y procesador de los servicios brindados por la App.
            </p>
            <p class="textBloque1">
                En estas Condiciones Generales se describen los derechos, responsabilidades y obligaciones del Usuario y
                de Yacaré al utilizar el servicio de procesamiento de pagos, la Plataforma y cualquier producto o
                servicio relacionado que ofrezca Yacaré (cualquiera de ellos, indistintamente, el “Servicio” y,
                conjuntamente, los “Servicios”, según corresponda).
            </p>
            <p class="textBloque1">
                El Usuario debe leer, entender y aceptar todas las condiciones establecidas en estas Condiciones
                Generales y demás políticas y principios incorporados a las mismas por referencia previo a su registro
                como Usuario de Yacaré y/o la utilización del Servicio. Yacaré se reserva el derecho de actualizar o
                modificar estas Condiciones Generales en los términos previstos en la Sección 13. En cualquier caso, la
                utilización del Servicio en su versión web o móvil, implica la aceptación por parte del usuario de las
                Condiciones Generales.
            </p>
            <p class="textBloque1">
                CUALQUIER PERSONA QUE NO ACEPTE ESTAS CONDICIONES GENERALES, LAS CUALES TIENEN CARÁCTER OBLIGATORIO Y
                VINCULANTE, DEBERÁ ABSTENERSE DE UTILIZAR EL APLICATIVO MÓVIL, EL SITIO Y/O LOS SERVICIOS.
            </p>
        </div>

        <div class="bloque">
            <div style="margin-bottom:30px">
                <span class="title-bloque2">
                    1. REQUISITOS PARA LA UTILIZACIÓN DE LOS SERVICIOS YACARÉ
                </span>
            </div>

            <p class="textBloque2">
                Para utilizar Yacaré, el Usuario debe contar con (i) DNI y CUIL o CUIT (ii) Disponer de un dispositivo
                móvil con acceso a Internet; (iii) Descargar la App desde las tiendas oficiales habilitadas; (iv)
                Generar un perfil con una contraseña para acceder a la App (en adelante, la “Cuenta” del Usuario).
            </p>
        </div>

        <div class="bloque">
            <div style="margin-bottom:30px">
                <span class="title-bloque2">
                    2. REGISTRO DE CUENTAS<br>
                    - CONSENTIMIENTO PARA LA UTILIZACIÓN DE LOS SERVICIOS YACARÉ
                </span>
            </div>

            <p class="textBloque2">
                <b>2.1.</b> Para disponer de los Servicios, el Usuario deberá aceptar estas Condiciones Generales y
                registrarse a través del formulario de registro que indica la App, validando su número de teléfono
                celular, asociando sus Datos Personales (en adelante «Datos Personales», los que se entienden porNombres
                y apellidos completos/DNI/Lugar y fecha de nacimiento/Domicilio/ Ocupación/ Estado civil/ Número de
                celular/email) y tomando una foto de su rostro “Selfie”o imágenes de su rostro en tiempo real de acuerdo
                con el procedimiento que indica la Plataforma.
            </p>
            <p class="textBloque2">
                Para la utilización de los Servicios, Yacarégenerará automáticamente una Clave Virtual Uniforme (“CVU”)
                vinculada a la Cuenta del Usuario, de conformidad con la normativa vigente.
            </p>
            <p class="textBloque2">
                Yacaré, en caso de que así lo disponga, podrá permitir la apertura de dos (2) tipos de Cuentas: (i)
                Cuenta Personal, disponible por defecto para cualquier persona que se registre en Yacaré, siempre que se
                cumplan los requerimientos correspondientes (la “Cuenta Personal”); y (ii) Cuenta Comercial, la cual
                sólo podrá obtenerse con ciertas validaciones que Yacaré considere pertinente (la “Cuenta Comercial”).
            </p>
            <p class="textBloque2">
                El Usuario podrá optar por cambiar de forma definitiva su Cuenta Personal por una Cuenta Comercial para
                gestionar el cobro de bienes y/o servicios, habilitando su Comercio a través del Sitio web de Yacaré <a
                    style="color: #FF6600;" href="https://apps.yacare.com/#/login">
                    https://apps.yacare.com/#/login</a>, ingresando con el mismo email y contraseña con que se encuentra
                registrado en el aplicativo y completando el formulario de registro Comercial que allí se encuentra.
                Yacaré podrá abstenerse de habilitar y suspender o deshabilitar o cerrar una Cuenta Comercial y/o una
                Cuenta Personal, a su entera discreción y sin necesidad de expresión de causa, con la mera notificación
                al Usuario.
            </p>
            <p class="textBloque2">
                El Usuario acepta que una vez habilitada la Cuenta Comercial, en caso de percibir cobros con la App, se
                le aplicarán las Tarifas (conforme dicho termino se define en la Sección 7) de acuerdo a la modalidad
                contratada.
            </p>
            <p class="textBloque2">
                Yacaré no se responsabiliza por la certeza de los Datos Personales provistos por los Usuarios. Todos los
                datos e información aportados por el Usuario tienen carácter de declaración jurada, por ello el Usuario
                garantiza y responde, en cualquier caso, de la veracidad, exactitud, integridad, vigencia, actualidad, y
                autenticidad de los datos e información ingresados.
            </p>
            <p class="textBloque2">
                El Usuario declara tener pleno conocimiento de las normas sobre “Prevención de Lavado de Activos y
                Financiamiento del Terrorismo proveniente de actividades ilícitas”, Ley 25.246, sus modificaciones y las
                disposiciones reglamentarias pertinentes.
            </p>
            <p class="textBloque2">
                El Usuario se compromete a no realizar ningún tipo de transacción que carezca de justificación económica
                o jurídica, o que sea de inusitada o injustificada complejidad realizada en forma aislada o reiterada.
                El Usuario declara que los fondos que va a ingresar a su/s Cuenta/s tendrán un origen lícito. El Usuario
                se compromete a colaborar con Yacaré aportando toda información y/o documentación adicional que pruebe
                fehacientemente su identidad, personería jurídica, domicilio, actividad, condición económica y
                financiera, y demás datos, a los efectos de su conocimiento como Usuario.
            </p>
            <p class="textBloque2">
                El Usuario declara que en caso de ser “sujeto obligado” de acuerdo a la Ley N° 25.246 (y
                modificatorias), cumple con las obligaciones propias de un sujeto obligado de acuerdo a lo establecido
                en la mencionada ley y normativas correspondientes de la Unidad de Información Financiera.
            </p>
            <p class="textBloque2">
                El Usuario declara conocer y haber leído la “Nómina de Personas Expuestas Políticamente” aprobada por
                Resolución N° 134/2018(y sus actualizaciones y modificatorias) de la Unidad de Información Financiera y
                haber informado correctamente, sobre si es o no es una persona políticamente expuesta.
            </p>
            <p class="textBloque2">
                Asimismo, se compromete a informar cualquier modificación que se produzca en este aspecto, dentro de los
                treinta (30) días corridos ocurrida la misma, mediante la presentación de una declaración jurada.
            </p>
            <p class="textBloque2">
                El Usuario reconoce y acepta expresamente que Yacaré podrá compartir los legajos de información y
                documentación del Usuario a otras sociedades del mismo grupo económico, a fines de dar cumplimiento a
                obligaciones regulatorias de conocimiento del cliente, de conformidad con lo dispuesto en el Artículo 21
                de la Resolución de UIF 76/2019, complementarias y modificatorias y de acuerdo a la Política de
                Protección de Datos Personalesde Yacaré.
            </p>
            <p class="textBloque2">
                En cumplimiento con las disposiciones de la Ley de Foreing Account Tax Compliance Act de Estados Unidos
                (FATCA) el Usuario manifiesta, con carácter de declaración jurada, que: (i) no es persona estadounidense
                (ciudadano y/o residente); ni (ii) actúa en nombre y representación de una persona estadounidense, (iii)
                en caso de ser persona de nacionalidad estadounidense se compromete a cooperar con Yacaré e informar
                todo lo requerido, a fin de facilitar que Yacaré proporcione al Internal Revenue Service de los Estados
                Unidos (IRS) información respecto de su persona y/o Cuenta.
            </p>
            <p class="textBloque2">
                A los efectos del intercambio de información de cuentas financieras de la Organización para la
                Cooperación y el Desarrollo Económico (OCDE), el Usuario manifiesta, con carácter de declaración jurada,
                tener domicilio fiscal en la República Argentina.
            </p>
            <p class="textBloque2">
                El Usuario reconoce y acepta que Yacaré se encuentra comprometida a fomentar y realizar sus negocios de
                forma ética y evitando cualquier práctica corrupta, alineando su actuación en todo momento a las
                disposiciones de la Ley de Responsabilidad Penal de las Personas Jurídicas N° 27.401.
            </p>
            <p class="textBloque2">
                <b>2.2.</b> Una vez registrado en Yacaré, el Usuario podrá acceder a todos los Servicios brindados por
                Yacaré, incluyendo realizar pagos por compras de bienes o servicios, recibir pagos por ventas de bienes
                o servicios, enviar, recibir y solicitar dinero a terceros, mediante el débito o acreditación de dinero
                en la Cuenta, como también utilizar o aplicar cualquier otra funcionalidad que en un futuro se ofrezca
                al Usuario, sujeto a los Términos y Condiciones de Uso.
            </p>
            <p class="textBloque2">
                <b>2.3.</b> En todos los casos, la Cuenta, cualquiera sea su clase, es personal, única e intransferible,
                y será asignada a un solo Usuario y está prohibida su venta, cesión o transferencia bajo ningún título.
                El Usuario no podrá permitir ni autorizar el uso de su Cuenta por terceras personas salvo en el caso
                excepcional de Cuenta Comercial.
            </p>
            <p class="textBloque2">
                <b>2.4.</b> La Cuenta estará denominada con un número de CVU, Alias y/o cualquier otro dato que fuera
                implementado por Yacaré o requerido por cualquier Autoridad de aplicación y cualquier referencia a
                dinero en Yacaré se entenderá hecha a la moneda de curso legal en la República Argentina, salvo en los
                casos que se indique expresamente otra moneda.
            </p>
            <p class="textBloque2">
                Yacaré se reserva el derecho de solicitar comprobantes y/o información adicional a efectos de corroborar
                la información entregada por un Usuario en materia de Datos Personales, así como de suspender temporal o
                definitivamente a aquellos Usuarios cuyos datos no hayan podido ser confirmados o en caso de detectar
                actividades sospechosas o incongruencias, sin que tal decisión genere para el Usuario derechos de
                indemnización o resarcimiento.Yacaré se reserva el derecho de solicitar comprobantes y/o información
                adicional a efectos de corroborar la información entregada por un Usuario en materia de Datos
                Personales, así como de suspender temporal o definitivamente a aquellos Usuarios cuyos datos no hayan
                podido ser confirmados o en caso de detectar actividades sospechosas o incongruencias, sin que tal
                decisión genere para el Usuario derechos de indemnización o resarcimiento.
            </p>
            <p class="textBloque2">
                <b>2.5.</b> Para acceder a su Cuenta, el Usuario deberá ingresar con su email y clave de seguridad
                personal elegida en el registro (“Contraseña de Ingreso”) que deberá conservar y utilizar para
                administrar y operar las gestiones que realice a través de la App o del sitio web de Yacaré.
            </p>
            <p class="textBloque2">
                <b>2.6.</b> El Usuario responsable de una cuenta Comercial (en adelante, “Administrador Comercial”) será
                el titular, representante legal y/o apoderado con suficientes facultades del comercio -persona humana o
                persona jurídica- registrado, y será el responsable exclusivo de del control y la gestión de todas
                aquellas operaciones que se realicen.
            </p>
            <p class="textBloque2">
                <b>2.7.</b> El Usuario, cualquier sea su clase, se obliga a mantener la confidencialidad de su
                Contraseña de Ingreso. En virtud de ello, el Usuario será el único y exclusivo responsable por todas las
                operaciones efectuadas en su Cuenta. El Usuario se compromete a notificar a Yacaré en forma inmediata y
                por medio idóneo y fehaciente, de cualquier uso no autorizado de su Cuenta, así como del ingreso o de
                intentos de ingreso por terceros no autorizados a la misma.
            </p>
            <p class="textBloque2">
                Yacaré y/o los emisores no responderán por uso indebido alguno de la Contraseña de Ingreso, ni de los
                servicios Yacaré, siendo el Usuario el único responsable de su utilización. En el caso de que un Usuario
                considere que su Contraseña de Ingreso puede haber sido conocida por un tercero, deberá cambiarla
                inmediatamente, a través de la App, seleccionando la opción “Recuperar contraseña” y siguiendo las
                instrucciones allí publicadas.
            </p>
            <p class="textBloque2">
                <b>2.8.</b> El Usuario brinda el consentimiento pleno para la utilización de los Servicios Yacaré,
                conforme lo siguiente:<br>
                a) El Usuario brinda su consentimiento para enrolar/vincular la/s cuenta/s a la vista de pago que usará
                en la billetera digital Yacaré.<br>
                Asimismo, el Usuario declara y reconoce que todas las cuentas a la vista y/o cuentasde pago enroladas
                son de su titularidad y provistas por Yacaré.<br>
                b) Toda instrucción de pago o de débito ordenada por el Usuario mediante la billetera digital Yacaré se
                cursarámientras esté vigente el consentimiento o la autorización otorgada por el Usuario.<br>
                c) Oportunamente, el Usuario tendrá la posibilidad de establecer y modificar parámetros de uso de su
                cuenta/s a la vista / de pago en la billetera digital.<br>
                d) Por último, el Usuario podrá desvincular la cuenta a la vista /de pago enrolada a través de la App de
                acuerdo a los procedimientos detallados en el punto 14 de las presentes Condiciones Generalesy las que
                se establezcan a futuro.
            </p>
        </div>


        <div class="bloque">
            <div style="margin-bottom:30px">
                <span class="title-bloque2">
                    3. GESTIÓN DE PAGOS ELECTRONICOS.
                </span>
            </div>

            <p class="textBloque2">
                <b>3.1.</b> Contrato de Gestión de Pagos Electrónicos.<br>
                El Usuario y Yacaré (conjuntamente, las «Partes»), podrán celebrar contratos de gestión de pagos
                electrónicos (cada uno, una «Solicitud de Gestión de Pago») mediante los cuales Yacaré brinde servicios
                de gestión o procesamiento de pagos de acuerdo a las instrucciones del Usuario (los “Servicios de
                Gestión de Pago”), a fin de pagar o percibir por cuenta y orden del Usuario, utilizando el aplicativo
                móvil “Yacaré” y/o la Plataforma Comercial para aquellos Usuarios que habiliten su Cuenta Comercial en
                el Sitio. Las Partes acuerdan que las Solicitudes de Gestión de Pagos que oportunamente completen se
                regirán por estas Condiciones Generales (juntamente con las condiciones específicas de cada Solicitud de
                Gestión de Pago, los «Términos y Condiciones del Servicio de Gestión de Pago»).
            </p>
            <p class="textBloque2">
                <b>3.2.</b> Mandato Irrevocable. Al realizar la Solicitud de Gestión de Pago, el Usuario otorgará un
                mandato irrevocable a Yacaré para (i) pagar por su cuenta y orden una determinada suma de dinero en
                relación a la cual se complete la Solicitud de Gestión de Pago (los «Fondos») y/o (ii) cobrar los Fondos
                por su cuenta y orden, sujeto a los Términos y Condiciones del Servicio de Gestión de Pago. El mandato
                irrevocable otorgado por el Usuario implica una autorización a favor de Yacaré para disponer en su
                nombre de ciertos Fondos de su Cuenta y transferirlos a cierto destinatario de acuerdo con sus
                instrucciones. Asimismo, el mandato irrevocable implica una autorización del Usuario a favor de Yacaré
                para recibir, cobrar y acreditar en su Cuenta los Fondos de acuerdo con sus instrucciones. Yacaré
                mantendrá los Fondos del Usuario en su Cuenta en las condiciones y plazos establecidos en estas
                Condiciones Generales y/u otras condiciones especiales o particulares que se establezcan para otros
                productos o servicios de Yacaré.Mandato Irrevocable. Al realizar la Solicitud de Gestión de Pago, el
                Usuario otorgará un mandato irrevocable a Yacaré para (i) pagar por su cuenta y orden una determinada
                suma de dinero en relación a la cual se complete la Solicitud de Gestión de Pago (los «Fondos») y/o (ii)
                cobrar los Fondos por su cuenta y orden, sujeto a los Términos y Condiciones del Servicio de Gestión de
                Pago. El mandato irrevocable otorgado por el Usuario implica una autorización a favor de Yacaré para
                disponer en su nombre de ciertos Fondos de su Cuenta y transferirlos a cierto destinatario de acuerdo
                con sus instrucciones. Asimismo, el mandato irrevocable implica una autorización del Usuario a favor de
                Yacaré para recibir, cobrar y acreditar en su Cuenta los Fondos de acuerdo con sus instrucciones. Yacaré
                mantendrá los Fondos del Usuario en su Cuenta en las condiciones y plazos establecidos en estas
                Condiciones Generales y/u otras condiciones especiales o particulares que se establezcan para otros
                productos o servicios de Yacaré.Mandato Irrevocable. Al realizar la Solicitud de Gestión de Pago, el
                Usuario otorgará un mandato irrevocable a Yacaré para (i) pagar por su cuenta y orden una determinada
                suma de dinero en relación a la cual se complete la Solicitud de Gestión de Pago (los «Fondos») y/o (ii)
                cobrar los Fondos por su cuenta y orden, sujeto a los Términos y Condiciones del Servicio de Gestión de
                Pago. El mandato irrevocable otorgado por el Usuario implica una autorización a favor de Yacaré para
                disponer en su nombre de ciertos Fondos de su Cuenta y transferirlos a cierto destinatario de acuerdo
                con sus instrucciones. Asimismo, el mandato irrevocable implica una autorización del Usuario a favor de
                Yacaré para recibir, cobrar y acreditar en su Cuenta los Fondos de acuerdo con sus instrucciones. Yacaré
                mantendrá los Fondos del Usuario en su Cuenta en las condiciones y plazos establecidos en estas
                Condiciones Generales y/u otras condiciones especiales o particulares que se establezcan para otros
                productos o servicios de Yacaré.
            </p>
            <span class="textBloque2">
                <b>3.3.</b> Celebración de la gestión de pagos<br><br>
                <div class="subBloque">
                    <p class="textBloque2">
                        <b>I. Celebración de la solicitud de pago: </b> El Usuario reconoce que es el exclusivo
                        responsable
                        por las instrucciones de pago y sus consecuencias. Yacaré no verificará la causa u obligación
                        que
                        originó la instrucción de pago, ni las demás circunstancias relativas a la instrucción de pago.
                        Las
                        instrucciones de pago introducidas en una Solicitud de Gestión de Pagos sólo podrán efectuarse a
                        través del aplicativo y/o Sitio web en caso de las Cuentas Comerciales. Ninguna instrucción
                        cursada
                        será procesada ni reputada válida, por otros medios ajenos a la Plataforma.
                    </p>
                    <p class="textBloque2">
                        <b>II. Responsabilidad por la solicitud: </b> Yacaré no será responsable por órdenes,
                        instrucciones,
                        Solicitudes de Gestión de Pago y/o pagos equivocados o incompletos causados por la introducción
                        errónea del Usuario.
                    </p>
                    <p class="textBloque2">
                        Yacaré no será responsable ni garantizará el cumplimiento de las obligaciones que hubiesen
                        asumido
                        los Usuarios con terceros en relación a los pagos a efectuar o a recibir a través de la
                        Plataforma.
                    </p>
                    <p class="textBloque2">
                        El Usuario reconoce y acepta que al realizar transacciones con otros Usuarios o terceros lo hace
                        por
                        su propia voluntad, prestando su consentimiento libremente y bajo su propio riesgo y
                        responsabilidad. En ningún caso Yacaré será responsable por daño directo, lucro cesante, o por
                        cualquier otro daño y/o perjuicio que haya podido sufrir el Usuario, debido a las transacciones
                        realizadas o no realizadas a través de la Plataforma de Yacaré. En virtud que Yacaré es ajeno a
                        la
                        obligación que dio origen a la Solicitud de Gestión de Pago, Yacaré no será responsable ni
                        verificará las causas, importe o cualquier otra circunstancia relativa a dicha Solicitud, así
                        como
                        respecto de la existencia, calidad, cantidad, funcionamiento, estado, integridad o legitimidad
                        de
                        los bienes o servicios ofrecidos, adquiridos o enajenados por los Usuarios y pagados utilizando
                        Yacaré, así como de la capacidad para contratar de los Usuarios y la veracidad de los datos
                        personales por ellos ingresados.
                    </p>
                    <p class="textBloque2">
                        En caso de que uno o más Usuarios o algún tercero inicien cualquier tipo de reclamo o acciones
                        legales contra otro u otros Usuarios, todos y cada uno de los Usuarios involucrados en dichos
                        reclamos o acciones eximen de toda responsabilidad a Yacaré y a sus directores, gerentes,
                        empleados,
                        agentes, operarios, representantes y apoderados. Los Usuarios tendrán idéntica asunción de
                        responsabilidad en relación a los medios de pago utilizados para sus transacciones, quienes no
                        garantizan el cumplimiento de las obligaciones que hubiesen asumido los Usuarios con terceros en
                        relación a los pagos a efectuar o a recibir a través de la Plataforma. Los Usuarios tienen un
                        plazo
                        de treinta (30) días desde la compra o pago para iniciar un reclamo contra otro u otros
                        Usuarios.
                        Una vez vencido este plazo, no podrán iniciar un reclamo desde el sitio de Yacaré.
                    </p>
                    <p class="textBloque2">
                        El Usuario asume, reconoce y acepta su total responsabilidad por las pérdidas que se originen,
                        en
                        especial si a través de su nombre de Usuario se impartieran instrucciones fraudulentas,
                        duplicadas,
                        no autorizadas o meramente erróneas, así como por los eventuales perjuicios que pueda causar a
                        Yacaré.
                    </p>
                    <p class="textBloque2">
                        <b>III. Utilización de la plataforma:</b> El Usuario que utilice la Plataforma como alternativa
                        para
                        el pago de los bienes y servicios que ofrezca y venda declara conocer y aceptar que no podrá:
                        (i)
                        realizar transacciones por nada adicional a la concreción de ventas genuinas propias de su giro
                        comercial, y/o envío o recepción de dinero; (ii) imponer un mínimo o un máximo de valores para
                        la
                        realización de transacciones; (iii) discriminar y/o inducir a los Usuarios a utilizar un medio
                        de
                        pago con preferencia a otro; (iv) permitir desdoblar una misma transacción de venta en dos o más
                        operaciones; (v) aceptar transacciones por compra de bienes o servicios diferentes de los que
                        representan el giro comercial usual de sus negocios; (vi) aceptar transacciones de operaciones
                        que
                        no sean efectuadas en virtud de la venta de bienes o servicios que comercializa en forma directa
                        con
                        el Usuario Comprador; (vii) aceptar transacciones que impliquen el otorgamiento de dinero
                        efectivo a
                        los Usuarios compradores; (viii) realizar transacciones ilegales; (ix) solicitar el
                        procesamiento de
                        reversiones o contracargos para compras realizadas con tarjeta de crédito en una tarjeta
                        diferente
                        de la tarjeta que haya sido utilizada para concretar la compra, ni aceptar dinero por parte del
                        Usuario que hubiera efectuado la compra del bien o servicio (el “Usuario Comprador”) en relación
                        a
                        una reversión o contracargo.
                    </p>
                    <p class="textBloque2">
                        Sin perjuicio de las demás obligaciones establecidas en este Acuerdo, el Comercio tendrá las
                        siguientes (i) Cumplir con la normativa aplicable con ocasión de su actividad comercial; (ii)
                        Conocer a cabalidad su negocio a fin de alertar a Yacaré sobre transacciones que por su número
                        y/o
                        cuantía se salgan de los parámetros habituales, y que por ende impliquen riesgo de fraude por
                        suplantación de identidad u otras actividades ilegales; (iv) Mantener actualizada su dirección
                        física, teléfono, dirección de correo electrónico e información de Cuenta Bancaria. La falta de
                        actualización de los datos en cuestión exonera a Yacaré de reclamos por falta de notificación;
                        (v)
                        Abstenerse de facilitar que terceros no Compradores, utilicen o se beneficien de la Plataforma,
                        sin
                        autorización expresa de Yacaré; (vi) Cumplir con los deberes tributarios, cambiarios y aduaneros
                        derivados de la importación, exportación y comercialización de los bienes o servicios pagados a
                        través de la Plataforma ; (vii) Suministrar a sus Usuarios Compradores información cierta,
                        fidedigna, suficiente, clara y actualizada respecto de los bienes o servicios en venta, del
                        precio a
                        pagar y de la entrega de los mismos; (viii) Asumir los reclamos que presenten sus Usuarios
                        Compradores en cuanto a cantidad, calidad, idoneidad, seguridad y entrega de los bienes o
                        servicios
                        vendidos; (ix) Expedir y archivar durante por lo menos dieciocho (18) meses posteriores a una
                        transacción copia del recibo o documento equivalente que evidencie que se entregó el bien o se
                        prestó el servicio al comprador y las facturas derivadas de los contratos de compraventa o de
                        prestación de servicios correspondientes. El Comercio suministrará a Yacaré dichos soportes, en
                        un
                        plazo máximo de cinco (5) días hábiles contados desde la fecha en que Yacaré se los requiera;
                        (xi)
                        Acatar los reglamentos y recomendaciones que Yacaré expida para que su sistema funcione de
                        manera
                        óptima y segura; (xii) Abstenerse de facilitar que virus, gusanos u otras rutinas de
                        programación
                        interfieran o dañen el sistema de Yacaré; (xiii) Abstenerse de adoptar prácticas que impongan
                        una
                        carga desproporcionada a la infraestructura tecnológica de Yacaré.
                    </p>
                </div>
            </span>
            <p class="textBloque2">
                <b>3.4.</b> Gestión de pagos de bienes y servicios
            </p>
            <p class="textBloque2">
                <b>3.4.1</b> El Usuario reconoce que el Servicio de la App solo permite gestionar pagos de bienes y/o
                servicios de los establecimientos habilitados en la Plataforma de pagos, en la medida que las facturas
                emitidas para el cobro cuenten con códigos QRs autorizados por las empresas emisoras/Comercios.
            </p>
            <p class="textBloque2">
                <b>3.4.2.</b> Para realizar el pago de un producto y/o servicio, el Usuario deberá ingresar ala App con
                su email y Contraseña de Ingreso, seleccionar la opción “Pagar” y escanear, con la cámara del celular,
                el código QR facilitado por el establecimiento. A fin de identificar la compra, el aplicativo anunciará
                el monto del producto y/o servicio que se desea abonar o el Usuario deberá ingresar el monto enunciado
                por el Comercio. El Usuario, deberá corroborar que los datos expresados sean correctos y de tener un
                medio de pago vinculado a su Cuenta, deberá seleccionar aquel con el que desea gestionarlo, o bien,
                cargar los datos de su tarjeta crédito y/o débito para proceder al pago. Finalmente, para concluir cada
                operación, en todos los casos que se empleen tarjetas de crédito y/o débito, el Usuario deberá ingresar
                el código de seguridad o código pin ubicado al dorso de su tarjeta y oprimir la opción “confirmar pago”.
            </p>
            <p class="textBloque2">
                <b>3.4.3.</b> El monto a pagar será definido en todo momento por los establecimientos adheridos y/o
                Comercios, en virtud de lo cual, es responsabilidad del Usuario verificar que éste sea correcto antes de
                efectuar la gestión del pago mediante el aplicativo móvil. Yacaré no será responsable ni verificará las
                causas, importe o cualquier otra circunstancia relativa al pago realizado o no realizado por el Usuario.
                Por lo cual, el Usuario reconoce que el aplicativo, en su calidad de gestor de pagos, no discrimina las
                facturas incluidas en un único QR. Si el Usuario emitiera un nuevo QR, que incluya facturas abonadas, el
                aplicativo tomará el pago como “nuevo pago”.
            </p>
            <p class="textBloque2">
                <b>3.4.4.</b> El Usuario acepta y reconoce que sólo podrá adherir al aplicativo, mediante los pasos que
                indique el sistema, las tarjetas de débito y/o crédito que sean de su titularidad y se encuentren
                habilitadas para operar. Así mismo, el Usuario reconoce que el Autorizador de la Tarjeta de
                crédito/débito (“Autorizador”) es el responsable de rechazar o aprobar un pago por los motivos que este
                lo determine. Si el Autorizador lo dispusiera, el Usuario deberá comunicarse con el centro de atención
                al cliente del emisor de la tarjeta de crédito/débito para solicitar la autorización del pago. En tal
                caso, el Usuario deberá iniciar nuevamente el proceso de pago para concluir la operación mediante el
                aplicativo móvil.
            </p>
            <p class="textBloque2">
                En todos los casos, Yacaré actúa exclusivamente como intermediaria en la gestión de los pagos efectuados
                y no es responsable, ni podrá dar respuestas por las situaciones que pudiera haber entre el Autorizador
                de la tarjeta y su cliente.
            </p>
            <p class="textBloque2">
                <b>3.4.5.</b> El Usuario acepta que el tiempo de acreditación de los pagos realizados mediante la App es
                de aproximadamente entre 24 y 48horas hábiles a partir de la realización de la operación, debido a los
                procesos de rendición establecidos entre Yacaré y el Comercio.
            </p>
            <p class="textBloque2">
                <b>3.4.6.</b> El Usuario podrá realizar el pago de facturas de los servicios habilitados en la App,
                ingresando a la sección de pagos de servicios, buscando al proveedor del servicio y cargando el número
                de referencia que identifica su servicio. Para finalizar la operación, el Usuario deberá ingresar el
                monto a pagar y registrar fondos suficientes en la Cuenta para efectuar el pago.
            </p>
            <p class="textBloque2">
                <b>3.5.</b> Celebración de la Solicitud de Transferencia de Saldo Yacaré.
            </p>
            <p class="textBloque2">
                <b>3.5.1.</b> Para poder gestionar la solicitud de transferencias de saldos (“Transferencia de Saldo”),
                el Usuario previamente deberá poseer Fondos en su Cuenta.
            </p>
            <p class="textBloque2">
                <b>3.5.2.</b> Para iniciar el proceso de Transferencia de Saldo, el Usuario deberá ingresar a la App o
                al Sitio web con su email y Contraseña de Ingreso, seleccionar la opción “Retirar dinero/Transferencia”
                y podrá escanear con la cámara del celular el código QR facilitado por el Usuario Receptor y/o
                Destinatario, o cargar los datos de la cuenta (CVU/CBU/Alias) del Destinatario. Para concluir la
                operación, el Usuario deberá ingresar el monto a transferir y oprimir la opción “transferir”.
            </p>
            <p class="textBloque2">
                <b>3.5.3.</b> Yacaré seguirá las instrucciones ingresadas por el Usuario siempre que hubiera Fondos
                suficientes para cumplir con las instrucciones dadas en la Solicitud de Transferencia de Saldo y para el
                pago de impuestos en caso de corresponder, caso contrario no se procesará dicha Solicitud.
            </p>
            <p class="textBloque2">
                <b>3.5.4.</b> Se aclara que el Usuario al registrarse en Yacaré y mantener una Cuenta activa, acuerda,
                acepta y autoriza recibir Fondos que oportunamente envíen otros Usuarios a su Cuenta y que se le debite
                cualquier cargo que resulte aplicable.
            </p>
            <p class="textBloque2">
                <b>3.6.</b> Celebración de la Solicitud de la Gestión de Cobro.
            </p>
            <p class="textBloque2">
                <b>3.6.1.</b> Para poder gestionar la solicitud de cobro, previamente el Usuario deberá registrar su
                Comercio en el Sitio web de Yacaré <a style="color: #FF6600;" href="https://apps.yacare.com/#/login">
                    https://apps.yacare.com/#/login</a>. En caso de que ya posea una Cuenta como usuario, deberá
                ingresar con el mismo email y Contraseña de Ingreso con la cual se encuentra registrado en la App, a fin
                de poder habilitar la Cuenta Virtual Comercial donde Yacaré acreditará los montos resultantes de las
                ventas que el Comercio realice, previo descuento de las Tarifas de Yacaré de acuerdo a la modalidad
                contratada.
            </p>
            <p class="textBloque2">
                <b>3.6.2.</b> Para percibir el cobro de una venta, el Comercio deberá exhibir su código QR al Usuario
                Comprador y este último deberá seleccionar la opción pagar y con la cámara de su celular, escanear el
                código QR correspondiente al comercio. La operación se dará por concluida cuando el Usuario confirme el
                pago.
            </p>
            <p class="textBloque2">
                <b>3.6.3.</b> Se considerará transacción exitosa cuando la operación sea aprobada por la entidad
                financiera. Las transacciones que no sean exitosas (cancelada, declinada y abandonada por el comprador)
                no son sujetas a cobro por procesamiento de pago.
            </p>
        </div>
        <div class="bloque">
            <div style="margin-bottom:30px">
                <span class="title-bloque2">
                    4. CONSIDERACIONES GENERALES DE LA CELEBRACIÓN DE GESTIÓN DE PAGO.
                </span>
            </div>
            <p class="textBloque2">
                <b>4.1.</b> Toda transacción que se efectúe desde la App, mediante email y Contraseña de Ingreso, se
                entenderá realizada por el Usuario, considerándose las mismas como válidas, legítimas y auténticas.
                Toda/s la/s operación/es se registrará/n en la fecha en que se curse/n.
            </p>
            <p class="textBloque2">
                <b>4.2.</b> La/s operación/es realizada/s por los Usuarios no podrán revocarse. La aprobación del pago
                se traducirá en un mensaje de confirmación como “Pago Aprobado” para cada operación en particular,
                visible en la pantalla del celular del Usuario al concluir cada transacción.
            </p>
            <p class="textBloque2">
                <b>4.3.</b> El Usuario reconoce que ingresando a la sección “Historial de pagos” del aplicativo móvil
                podrá consultar el estado de las transacciones realizadas, el estado de las transacciones hechas por los
                Usuarios Compradores (en caso de tener habilitada una Cuenta Comercial) y el valor de los Saldos
                existentes y disponibles a transferir a su Cuenta Bancaria.
            </p>
            <p class="textBloque2">
                <b>4.4.</b> Por cada operación realizada, el Usuario acepta que los comprobantes de pagos y constancias
                electrónicas emitidas por Yacaré serán tenidas como prueba de su voluntad de haber realizado las
                transacciones; del mismo modo que, acepta expresamente la información que surja de los soportes
                magnéticos, microfichas o listados de computación aportados por el Autorizador de la Tarjeta. Asimismo,
                el Usuario reconoce que la rendición y liquidación no es un proceso de responsabilidad de la App, por
                ende, el Comercio podrá solicitar documentación adicional para corroborar el pago realizado mediante el
                aplicativo, por ejemplo, el detalle del resumen de gastos de la tarjeta de crédito utilizada.
            </p>
        </div>
        <div class="bloque">
            <div style="margin-bottom:30px">
                <span class="title-bloque2">
                    5. INGRESO, APLICACIÓN Y RETIRO DE LOS FONDOS
                </span>
            </div>
            <p class="textBloque2">
                <b>5.1 Ingreso de los Fondos por el Usuario.</b>
            </p>
            <p class="textBloque2">
                Para que la plataforma pueda realizar la instrucción de pagos, cualquiera sea su clase, el Usuario
                deberá contar con Fondos en su Cuenta. El ingreso de Fondos podrá ser realizada por el Usuario mediante
                la utilización de: (i) Cualquiera de los medios disponibles a tal fin y autorizados por Yacaré (Rapipago
                y/o Transferencia Bancaria); o(ii) Por medio de la opción Cobrar habilitada en la Plataforma para la
                percepción de Saldo entre usuarios. Por cada ingreso de dinero, Yacaré podrá percibir una comisión
                conforme se detalla en <a style="color: #FF6600;" href="https://www.yacare.com/tarifas/">
                    https://www.yacare.com/tarifas/</a>.. Yacaré se deducirá dicha comisión previo al envío de los
                fondos
                a la CVU del Usuario.
            </p>
            <p class="textBloque2">
                Los tiempos de acreditación en la Cuenta del Usuario estarán sujetos a la modalidad empleada, siendo
                por: (i) Rapipago: Acreditación inmediata; (ii) Transferencia Bancaria: entre 24 a 48hs hábiles; (iii)
                Transferencia de Saldo Yacaré: Acreditación inmediata. En todos los casos Yacaré realizará los esfuerzos
                razonables para asegurar el cumplimiento del plazo antes indicado. No obstante a ello, el Usuario
                entiende que, por determinados factores, en su mayoría externos a Yacaré, se pueden originar retrasos,
                motivo por el cual el Usuario exime a Yacaré de toda responsabilidad por los inconvenientes o perjuicios
                derivados. Yacaré ingresará en la Cuenta del Usuario el importe que efectivamente haya sido acreditado
                por el medio de pago utilizado, ello independientemente del monto declarado por el Usuario en aquellos
                supuestos en que el medio de pago elegido permita realizar una declaración por un monto de dinero
                distinto al realmente ingresado.
            </p>
            <p class="textBloque2">
                En su Cuenta el Usuario sólo puede recibir envíos de dinero o pagos a través de las herramientas
                habilitadas en la Plataforma. Si Yacaré considera que posiblemente un Usuario podría estar utilizando de
                manera irregular los mecanismos para agregar Fondos, comprendiendo, pero no limitando la publicación o
                impresión de la boleta de depósito para uso de usuarios no propietarios de la Cuenta, Yacaré podrá
                aplicar lo dispuesto en la Sección 8 de estas Condiciones generales.
            </p>
            <p class="textBloque2">
                El Usuario se compromete a no aplicar ningún cargo adicional por aceptar pagos o recibir fondos a través
                de la Plataforma.
            </p>
            <p class="textBloque2">
                <b>5.2. Disponibilidad de los Fondos.</b>
            </p>
            <p class="textBloque2">
                Los Fondos que se acrediten en la Cuenta del Usuario quedarán disponibles en los plazos señalados según
                el detalle de Tarifas y plazos de disponibilidad de Fondos.
            </p>
            <p class="textBloque2">
                El Usuario será responsable por el pago de cualquier multa, tasa, penalidad, daño, costo, o reclamo, que
                sea aplicado a Yacaré por parte de empresas adquirentes y/o marcas de tarjetas de crédito, como
                resultado de niveles excesivos de contracargos relacionados con las transacciones hechas por el Usuario.
            </p>
            <p class="textBloque2">
                Toda información sobre los Fondos disponibles y acreditados en la Cuenta debe ser siempre verificada por
                el Usuario a través de la Plataforma de Yacaré, accediendo con su dirección de e-mail y Contraseña de
                Ingreso a través de la App o por medio del Sitio web. Yacaré no será responsable por las conductas del
                Usuario que se originen o vinculen con información contenida en correos electrónicos falsos o que
                aparenten provenir de Yacaré que sean enviados por terceros sin relación con Yacaré ni sus sociedades
                relacionadas; como así tampoco responderán por cualquier consecuencia dañosa derivada de tales
                conductas, ni por la circulación de los mencionados correos electrónicos falsos.
            </p>
            <p class="textBloque2">
                <b>5.3. Instrucciones respecto a los Fondos.</b>
            </p>
            <p class="textBloque2">
                Yacaré seguirá las instrucciones ingresadas por el Usuario, sea para: (i) realizar un pago o envío de
                los Fondos en su Cuenta o depositados a tal efecto o; (ii) acreditar y/o recibir los Fondos en su
                Cuenta. Se aclara que el Usuario al registrarse en Yacaré y mantener una Cuenta activa, acuerda, acepta
                y autoriza recibir Fondos que oportunamente envíen otros Usuarios a su Cuenta y que se le debite
                cualquier cargo que resulte aplicable.
            </p>
            <p class="textBloque2">
                <b>5.4. Retiros.</b>
            </p>
            <p class="textBloque2">
                Una vez que los Fondos acreditados en la Cuenta del Usuario estén disponibles, el Usuario podrá optar
                por: (i) retirar todo o parte del saldo disponible en su Cuenta; o (ii) mantener los Fondos para
                utilizarlos en otra oportunidad. El Usuario reconoce y acepta que: (a) el retiro de los Fondos quedará
                supeditado al previo pago de cualquier deuda que el Usuario mantuviera con Yacaré, cualquiera fuera su
                causa, y (b) solamente los Usuarios que residan en Argentina estarán habilitados para retirar Fondos de
                Yacaré.
            </p>
            <p class="textBloque2">
                Los retiros de Fondos se harán mediante transferencia a una cuenta bancaria indicada oportunamente por
                el Usuario, y conforme a sus instrucciones, o a través de Rapipago. Sin perjuicio de ello, Yacaré podrá
                limitar los retiros a cuentas bancarias que no sean de titularidad del Usuario que solicite el retiro.
            </p>
            <p class="textBloque2">
                Dicha transferencia puede tardar hasta dos (2) días hábiles después de que se realiza la solicitud de
                retiro. Debido a demoras originadas por el banco, la notificación o mensaje de Yacaré que confirma que
                el dinero está acreditado en la cuenta bancaria indicada puede llegar al tercer día hábil desde que se
                hizo la solicitud de retiro de dinero. Cualquier gasto originado por la transferencia estará a cargo del
                Usuario.
            </p>
            <p class="textBloque2">
                Por razones de seguridad, Yacaré podrá bloquear los retiros de fondos solicitados por aquellos Usuarios
                a los cuales se les haya detectado y/o posean fuertes indicios o sospechas de que los Servicios de
                Yacaré hayan sido utilizados para realizar actividades fraudulentas, ilícitas y/o en contra de las
                Condiciones Generales y/o sospechas de violación de preceptos legales por los cuales Yacaré deba
                responder.
            </p>
            <p class="textBloque2">
                <b>5.5. Límites.</b>
            </p>
            <p class="textBloque2">
                Yacaré determinará un importe máximo para las Solicitudes de Gestión de Pagos e ingresos de Fondos,
                monto que podrá variar de acuerdo al método de pago elegido, tipo de Solicitud y/o a criterio de Yacaré
                e incluso podrá ser modificado en cualquier momento. El Usuario podrá chequear estos montos ingresando
                <a style="color: #FF6600;" href="https://www.yacare.com/tarifas/">
                    https://www.yacare.com/tarifas/</a>.
            </p>
            <p class="textBloque2">
                <b>5.6.</b> Reversiones, contracargos, desconocimiento de cargos efectuados por tarjeta decrédito y/o
                débito.
            </p>
            <p class="textBloque2">
                Sin perjuicio de lo detallado en esta sección, se informa que en el caso que un Usuario haya realizado
                un retiro de Fondos y quien le envió los Fondos o el titular del medio de pago utilizado realizara una
                cancelación, anulación, contracargo, desconocimiento o reversión sobre los importes involucrados en la
                operación con posterioridad al envío, cualquiera sea el medio de pago utilizado para ingresar el dinero,
                dichos importes serán descontados y debitados de la Cuenta del Usuario Destinatario de los Fondos. En
                virtud de ello, el Usuario autoriza expresamente a Yacaré a debitar Fondos de su cuenta necesarios para
                cubrir la anulación, contracargo, desconocimiento o reversión, y si no dispusiera de fondos suficientes,
                a debitarlos de cualquier otro ingreso futuro de Fondos a su cuenta, o el Usuario se compromete a
                pagarlos dentro de los treinta (30) días siguientes al descuento de los Fondos. Se establece que, a
                efectos de impugnar la devolución de los Fondos, será importante cualquier prueba que el Usuario
                Destinatario de los mismos pudiera aportar a Yacaré en su defensa, pero ello no implicará que los Fondos
                sean acreditados nuevamente ni que Yacaré se comprometa a impugnar la devolución del cargo incluso si el
                Usuario ha proporcionado pruebas. En caso de una anulación, contracargo, desconocimiento o reversión, el
                Usuario receptor de los Fondos podrá responder ante Yacaré por el importe involucrado más cualquier otro
                costo o gasto aplicable. Yacaré podrá iniciar las medidas judiciales o extrajudiciales que estime
                pertinentes a los efectos de obtener el pago de dichos fondos. El Usuario receptor de Fondos se
                compromete a conservar la documentación respaldatoria de la operación de venta del bien o producto
                efectuada por Yacaré, inclusive aquella que compruebe el envío o entrega del bien o producto en
                cuestión, por el plazo mínimo de un año contado a partir de la recepción de los Fondos.
            </p>
            <p class="textBloque2">
                El Usuario declara conocer y aceptar que el medio de pago utilizado podrá retener un pago o liquidación
                ante incumplimientos del Usuario a estas Condiciones Generales.
            </p>
            <p class="textBloque2">
                <b>5.7. Responsabilidad por los Fondos.</b>
            </p>
            <p class="textBloque2">
                Se establece que Yacaré mantendrá los Fondos de las Cuentas en cuentas bancarias a su nombre (ambas
                denominadas «Cuenta Recaudadora») en entidades financieras del sistema financiero argentino, (el/los
                «Banco/s») y podrá usar diversos agentes de transferencia de dinero. Yacaré no será responsable en
                ningún caso por la insolvencia del Banco, entidad financiera o agente utilizado para la transferencia de
                los Fondos o cualquier cambio legal o regulatorio que afecte la cuenta en la cual los Fondos sean
                depositados por Yacaré. En dicho caso, el Usuario deberá entregar a Yacaré todas las cantidades
                adicionales necesarias para que Yacaré pueda cumplir con su mandato.
            </p>
            <p class="textBloque2">
                Los Usuarios eximen de responsabilidad a Yacaré por situaciones que pudieran afectar a las entidades
                bancarias, financieras y/o agentes donde están depositados los fondos de las Cuentas, como por
                situaciones políticas y económicas que pudieran presentarse en el país, y que sean ajenas a Yacaré. En
                estos casos, los Usuarios no podrán imputarle responsabilidad alguna a Yacaré, sus filiales o
                subsidiarias, empresas controlantes y/o controladas, ni exigir el reintegro del dinero o pago por lucro
                cesante, en virtud de perjuicios resultantes de este tipo de situaciones ni por órdenes de pago no
                procesadas por el sistema o rechazadas, cuentas suspendidas o canceladas.
            </p>
            <p class="textBloque2">
                Los Usuarios reconocen que Yacaré depositará los fondos entregados bajo las Solicitudes de Gestión de
                Pago en la/s Cuenta/s Recaudadora/s mencionadas anteriormente. Por lo tanto, en las situaciones
                descritas en el párrafo anterior Yacaré no estará obligado a seguir las instrucciones del Usuario en
                caso de existir distintas opciones de reprogramación, canje, disposición, conversión o devolución de los
                fondos. En esas situaciones, Yacaré tendrá el derecho a optar por la opción que, a su solo criterio, sea
                la más conveniente pudiendo Yacaré optar incluso por aquella que considere más apropiada a fin de
                liquidar de manera rápida, sencilla y ordenada los fondos depositados en el Banco aun cuando implique
                reducciones, quitas o esperas en los montos depositados.
            </p>
        </div>

        <div class="bloque">
            <div style="margin-bottom:30px">
                <span class="title-bloque2">
                    6. BOTÓN DE PAGO
                </span>
            </div>
            <p class="textBloque2">
                La presente sección se aplica específicamente al uso del botón de pago («Botón de Pago») ofrecido por
                Yacaré, denominado como «Herramientas de Venta».
            </p>
            <p class="textBloque2">
                <b>6.1.</b> Requisitos. Para utilizar alguna de las Herramientas de Venta se requiere ser un Usuario
                previamente registrado y la autorización de Yacaré. Yacaré se reserva el derecho de solicitar
                información adicional o verificación de los Datos Personales. Los Usuarios que utilicen las Herramientas
                de Venta para vender, se denominarán en adelante los «Vendedores» y los Usuarios que las utilicen las
                Herramientas de Venta para comprar, se denominarán, en adelante, los «Compradores».
            </p>
            <p class="textBloque2">
                <b>6.2.</b> Prohibiciones. Se prohíbe la utilización de cualquiera de las Herramientas de Venta, en
                cualquier sitio web que: (i) tenga contenido o permita o realice cualquier actividad contraria a las
                disposiciones legales y administrativas, la moral y las buenas costumbres y/o actividades o bienes cuya
                comercialización esté prohibida en los términos y condiciones de Yacaré; o (ii) promueva o tenga
                contenidos de sexo en el que participen menores de 18 años, relacionados con pedofilia, pornografía,
                desnudos de menores, ya sean reales o simulados; o (iii) de cualquier modo involucre menores de 18 años,
                o se trate de películas o fotografías que hayan sido tomadas de forma ilegal de menores de 18 años o sin
                el consentimiento de las personas que en ellas aparecen; o (iv) promueva la violencia de cualquier tipo,
                la discriminación de cualquier tipo, prostitución, lavado de dinero, tráfico de armas, de personas o de
                animales, u otras actividades ilegales; y/u (v) ofrezca contenidos, bienes o servicios que violen
                cualquier legislación vigente, en especial aquellas referidas a la protección de derechos de propiedad
                intelectual, piratería de software, etc. Yacaré podrá dar por terminado este Contrato y/o suspender,
                cancelar, temporal o definitivamente una Cuenta, sin notificación previa, en caso que determine que el
                Usuario y/o el sitio web donde se utiliza una Herramienta de Venta, no se adecua en todo o en parte a la
                ley o las Condiciones Generales o en caso de descubrirse o sospecharse comportamientos fraudulentos o
                que atenten contra la imagen de Yacaré, sus accionistas, controlantes, controladas, filiales o
                subsidiarias, funcionarios, empleados, directores, agentes, y/o sus usuarios y/o terceros. Asimismo,
                Yacaré se reserva el derecho de iniciar las acciones judiciales o extrajudiciales que estime
                pertinentes.
            </p>
            <p class="textBloque2">
                <b>6.3. </b>Costos por recibir dinero por Yacaré. La Plataforma mantendrá actualizada la lista de costos
                por ventas en la sección correspondiente.
            </p>
            <p class="textBloque2">
                <b>6.4.</b> Códigos de las Herramientas de venta. Luego de la apertura de su Cuenta y de la autorización
                para utilizar alguna de las Herramientas de Venta, el Usuario podrá colocar en su sitio web, alguno de
                los códigos facilitados por Yacaré para generar el Carrito de Compras o el Botón Comprar Ahora, con los
                parámetros necesarios para dirigir a sus usuarios a nuestro Sitio (los «Códigos»). Los Códigos
                mencionados anteriormente podrán tener distintas formas, según la disponibilidad de Yacaré y en ningún
                caso podrán ser modificados por el Usuario. Yacaré se reserva el derecho de actualizar o modificar
                periódicamente el contenido y/o apariencia de las Herramientas de Venta y de las URL donde estén
                direccionados los Códigos. Yacaré no será responsable si los Códigos fueran modificados y con ello se
                cause un daño o perjuicio a un tercero.
            </p>
            <p class="textBloque2">
                <b>6.5.</b> Responsabilidad por el sitio o el comercio donde se utilicen las Herramientas de Venta y la
                actividad del Vendedor. El Vendedor será el único y exclusivo responsable por los contenidos de su sitio
                Web, incluyendo con respecto a la exhibición de precios o promociones que puede ofrecer a través de
                Yacaré. En caso que uno o más usuarios o algún tercero inicie cualquier tipo de reclamo o acción legal,
                administrativa o extrajudicial contra Yacaré, sus accionistas, controlantes, controladas, filiales o
                subsidiarias, funcionarios, empleados, directores, agentes y empleados, el Vendedor involucrado en
                dichos reclamos o acciones eximen y se compromete a mantener indemne de toda responsabilidad a Yacaré y
                a sus accionistas, controlantes, controladas, filiales o subsidiarias, funcionarios, empleados,
                directores, agentes, representantes y apoderados. Asimismo, ambas Partes declaran ser contratistas
                independientes, sin ninguna relación societaria o comercial fuera de la pactada en el presente acuerdo,
                y cada una de ellas mantendrá indemne a la otra por cualquier reclamo derivado de las obligaciones
                impositivas, laborales o previsionales que estuvieran a su cargo. Ninguna de las partes inducirá a error
                a persona alguna sobre su carácter de parte contractual independiente de la otra ni obligará a la otra
                parte frente a terceros. El incumplimiento de esta obligación por el Vendedor habilitará a Yacaré a
                rescindir el presente acuerdo de pleno derecho en cualquier momento.
            </p>
        </div>

        <div class="bloque">
            <div style="margin-bottom:30px">
                <span class="title-bloque2">
                    7. TARIFAS.
                </span>
            </div>
            <p class="textBloque2">
                Por la utilización de los Servicios, el Usuario acepta pagar a Yacarélos costos, cargos y comisiones
                cada vez que reciba Fondos en su Cuentao realice ingresos, retiros o transacciones de su Cuenta, bajo
                determinadas condiciones(la/s «Tarifa» y/o “Tarifas”).En virtud de ello, el Usuario autoriza a Yacaré a
                descontar y retener las Tarifas o cualquier otro importe debido de los fondos disponibles en su Cuenta.
                Asimismo, el Usuario autoriza a Yacaré a descontar y retener de los fondos disponibles en su Cuenta
                cualquier importe adeudado a empresas relacionadas con quien Yacaré tuviera algún acuerdo comercial en
                tal sentido. Se aclara que Yacaré informará al Usuario cuales son estas empresas.
            </p>
        </div>

        <div class="bloque">
            <div style="margin-bottom:30px">
                <span class="title-bloque2">
                    8. POLÍTICA ANTE OPERACIONES SOSPECHOSAS
                </span>
            </div>
            <p class="textBloque2">
                <b>8.1.</b> Si Yacaré considerara una sospecha o indicio de utilización de la App para alguna actividad
                prohibida por la ley o las presentes Condiciones generales, podrá rechazar, cancelar o suspender una
                transacción, y/o bloquear temporalmente el acceso y uso del aplicativo móvil y/o la utilización o
                disponibilidad de funcionalidades y/o cancelar definitivamente la cuenta del Usuario. En tal caso, el
                Usuario responderá por los daños y perjuicios que pueda haber ocasionado a Yacaré, empleados,
                directores, agentes, y/o apoderados, a cuyos efectos Yacaré se reserva el derecho de iniciar las
                acciones judiciales o extrajudiciales que estime pertinentes.
            </p>
            <p class="textBloque2">
                <b>8.2.</b> Yacaré bajo los términos de la ley N°25.246 del Código Penal Argentino, se verá obligado a
                informar a la Unidad de Información Financiera (UIF) todo hecho ilícito identificado mediante el
                monitoreo de las transacciones realizadas, para asegurar que éstas se ajustan al perfil del cliente, a
                los efectos de prevenir e impedir el delito de lavado de activos y el delito de financiación del
                terrorismo.
            </p>
            <span class="textBloque2">
                <b>8.3.</b> El Usuario deberá respetar estos Términos y condiciones de Uso. Las infracciones por acción
                u omisión de las presentes Términos y condicioens de Uso generarán el derecho a favor de Yacaré de
                suspender la Cuenta del Usuario que las haya realizado, cualquiera que fuese su clase, por las
                siguientes razones: <br> <br>
                <div class="subBloque">
                    <p class="textBloque2">
                        I. Por considerarlo violatorio de estas Condiciones generales y/o de la Política de Privacidad
                        de estos Servicios Digitales, ofensivo, ilegal, violatorio de derechos de terceros, contrario a
                        la moral y buenas costumbres y amenaza la seguridad de otros Usuarios.
                    </p>
                    <p class="textBloque2">
                        II. De seguridad, cuando se produzcan 3 (tres) intentos fallidos y consecutivos de ingreso, de
                        la Contraseña de Ingreso de manera errónea.
                    </p>
                    <p class="textBloque2">
                        III. Ante la detección de operaciones inusuales que puedan afectar al Comercio.
                    </p>
                    <p class="textBloque2">
                        IV. Ante la detección de comportamientos inusuales del Comercio que puedan afectar al servicio
                        brindado por la Plataforma Comercial Yacaré.
                    </p>
                    <p class="textBloque2">
                        V. Otras restricciones dispuestas por autoridades judiciales, o administrativas.
                    </p>
                    <p class="textBloque2">
                        Para solicitar el desbloqueo en los casos previstos en los puntos III y IV, el Comercio deberá
                        comunicarse vía e-mail a
                        <span style="color:#FF6600">tucuenta@yacare.com.</span> En el caso previsto en el punto IV, la
                        restricción
                        cesará con orden de la misma autoridad que hubiera impartido la instrucción.
                    </p>
                </div>
            </span>
        </div>

        <div class="bloque">
            <div style="margin-bottom:30px">
                <span class="title-bloque2">
                    9. POLÍTICA DE CORRECTO USO DE MARCAS Y COMUNICACIÓN DE YACARÉ EN EL SITIO WEB DEL VENDEDOR.
                </span>
            </div>
            <p class="textBloque2">
                <b>9.1. Uso de marcas, logos y demás derechos de propiedad intelectual.</b>
            </p>
            <p class="textBloque2">
                Yacaré es titular y/o licenciatario de los derechos de propiedad intelectual puestos a disposición de
                los Usuarios para la utilización de los Servicios.
            </p>
            <p class="textBloque2">
                El Vendedor se obliga a utilizar los contenidos de conformidad con lo estipulado en el presente acuerdo
                y las instrucciones de Yacaré.
            </p>
            <p class="textBloque2">
                En la difusión, promoción y utilización de la plataforma de pagos Yacaré y las Herramientas de Ventas,
                el Vendedor se obliga a utilizar exclusivamente aquellos logos, banners y demás material promocional que
                sea proporcionado por Yacaré y con su previa autorización.
            </p>
            <p class="textBloque2">
                El Vendedor se abstendrá de utilizar banners o logos diseñados por sí y/o terceros, como cualquier otro
                material promocional utilizando derechos intelectuales de Yacaré, sin autorización previa y escrita de
                Yacaré.
            </p>
            <p class="textBloque2">
                <b>9.2. Página de inicio del Vendedor.</b><br>
                Logo, comunicación de promociones bancarias y medios de pago habilitados. El Vendedor se obliga a
                comunicar y utilizar en la página de inicio de su sitio web las marcas, logos, banners de promociones
                bancarias y medios de pago.
            </p>
            <p class="textBloque2">
                <b>9.3. Sección medios de pagos del sitio web del Vendedor: Comunicación.</b><br>
                El Vendedor se compromete a comunicar a su base de usuarios que la plataforma de pago en su sitio web es
                provista por Yacaré, a cuyo fin lo informará en forma clara e inequívoca en la sección de selección de
                medio de pago, mediante el uso del banner de selección de medio de pago.
            </p>
            <p class="textBloque2">
                <b>9.4. Posicionamiento Yacaré.</b><br>
                En caso de que el Vendedor cuente con más de un proveedor de soluciones pagos, deberá posicionar el
                banner de selección de medio de pago de Yacaré en la primera o segunda posición.
            </p>
            <span class="textBloque2">
                <b>9.5. Integración de Yacaré.</b><br><br>
                El Vendedor debe integrar Yacaré en su sitio web cumpliendo con las políticas de integración efectiva de
                Yacaré. Las cuales incluyen:
                <div class="subBloque">
                    <p class="textBloque2">
                        <b>i. Provisión del e-mail del Comprador al momento de conexión entre el sitio web del Vendedor
                            y Yacaré. A tal fin, el Vendedor declara contar con las autorizaciones de los
                            Compradores.</b>
                    </p>
                    <p class="textBloque2">
                        <b>ii. Implementación de la versión de checkout más actualizada de Yacaré.</b>
                    </p>
                    <p class="textBloque2">
                        <b>ii. Implementación de la versión de checkout más actualizada de Yacaré.</b>
                    </p>
                </div>
            </span>
            <p class="textBloque2">
                <b>9.6.</b> Uso de marcas, logos y demás derechos de propiedad intelectual de los Vendedores. Los
                Vendedores otorgan a Yacaré, durante la vigencia de este acuerdo, una autorización de uso gratuito y sin
                límite temporal del nombre comercial, marcas, logos, símbolos, emblemas, colores y/o diseños del
                Vendedor que fueran remitidos a Yacaré a la casilla de e-mail del representante comercial
                correspondiente (en adelante, las «Marcas del Vendedor»), para su utilización en acciones promocionales,
                publicitarias y/o comunicaciones relacionadas con el servicio de Yacaré. La autorización conferida
                faculta a Yacaré a exhibir, reproducir, difundir y/o publicar las Marcas del Vendedor en cualquier medio
                de comunicación y en cualquier soporte.
            </p>
        </div>

        <div class="bloque">
            <div style="margin-bottom:30px">
                <span class="title-bloque2">
                    10. DECLARACIONES Y OBLIGACIONES DE LOS USUARIOS.
                </span>
            </div>
            <p class="textBloque2">
                <b>10.1. Capacidad.</b><br> Los Servicios sólo están disponibles para personas que tengan capacidad
                legal para contratar. No podrán utilizar los servicios las personas que no tengan esa capacidad, los
                menores de edad o Usuarios de Yacaré que hayan sido suspendidos temporalmente o inhabilitados
                definitivamente. Si estás registrando un Usuario como Empresa y/o Comercio, debes tener capacidad para
                contratar a nombre de tal entidad y de obligar a la misma en los términos de este Acuerdo.
            </p>
            <p class="textBloque2">
                <b>10.2. Declaraciones del Usuario.</b><br> Usos Prohibidos. El Usuario manifiesta que el objeto por el
                cual se celebra la Solicitud de Gestión de Pago no infringe ninguna ley aplicable, ni es por un
                servicio, venta o transmisión que está prohibida por la ley o las Condiciones Generales, tales como y
                sin limitarse a: (i) juegos de azar, apuestas, etc., salvo que se encuentre regulado por legislación
                especial; (ii) tráfico de armas, de personas, de animales, etc.; (iii) lavado de dinero y/o terrorismo;
                (iv) pornografía, prostitución o pedofilia; y/o (vi) cualquier tipo de actividad que pueda ser
                considerada fraudulenta o ilegal o sospechosa de serlo.
            </p>
            <p class="textBloque2">
                El Usuario no utilizará los servicios de Yacaré para transmitir material que constituya un delito o bien
                que pueda dar lugar, directa o indirectamente a responsabilidades civiles o que infrinjan las
                Condiciones Generales de Yacaré.
            </p>
            <p class="textBloque2">
                Asimismo, queda absolutamente prohibida la utilización de Yacaré para efectuar cualquier operación
                efectuada por un Usuario en su propio beneficio y/o entre dos o más Usuarios que pueda considerarse o
                ser entendida como adelanto de efectivo o préstamo, así como el ingreso de Fondos sin tener un destino
                específico o relacionado con una transacción comercial. Yacaré considerará, sin limitación, adelanto de
                efectivo a aquella operación en la que detecte que un Usuario agrega Fondos a su Cuenta y retira dichos
                fondos; también se incluye dentro de esta actividad cuando un Usuario ingresa una Solicitud de Gestión
                de Pago a favor de otro Usuario quien posteriormente realiza a su favor una nueva Solicitud de Gestión
                de Pago, quien finalmente solicita el retiro de tales Fondos.
            </p>
            <p class="textBloque2">
                Si Yacaré considera que hay una sospecha o indicio de la utilización de Yacaré para alguna actividad
                prohibida por la ley o los Términos y Condiciones Generales de Yacaré, podrá rechazar, cancelar o
                suspender una Solicitud de Gestión de Pago, y/o bloquear temporalmente el acceso y uso de una Cuenta y/o
                la utilización o disponibilidad de funcionalidades y/o cancelar definitivamente una Cuenta. En tal caso,
                el Usuario responderá por los daños y perjuicios que pueda haber ocasionado a Yacaré, sus controlantes,
                controladas, filiales o subsidiarias, funcionarios, empleados, directores, agentes, y/o empleados, a
                cuyos efectos Yacaré se reserva el derecho de iniciar las acciones judiciales o extrajudiciales que
                estime pertinentes.
            </p>
            <p class="textBloque2">
                El Usuario será exclusiva e ilimitadamente responsable por los perjuicios que su conducta pueda causar a
                Yacaré o a los restantes Usuarios de los servicios de Yacaré.
            </p>
            <p class="textBloque2">
                <b>10.3. Utilización del servicio por cuenta propia.</b><br>
                Solamente se permite utilizar los Servicios en nombre propio y no en representación y/o por cuenta de
                terceros. El Usuario no revenderá los Servicios a terceros.
            </p>
            <p class="textBloque2">
                <b>10.4. Yacaré no es entidad financiera.</b><br>
                Se deja expresamente aclarado que Yacaré no es una entidad financiera ni presta al Usuario ningún
                servicio bancario o cambiario, Yacaré sólo brinda un servicio de gestión de pagos por cuenta y orden de
                los Usuarios según las condiciones establecidas en estas Condiciones generales.
            </p>
            <p class="textBloque2">
                <b>10.5. Intereses.</b><br>
                Los Fondos acreditados en la Cuenta no generan intereses y el Usuario podrá disponer libremente de ellos
                para realizar las operaciones descritas en el presente, ello una vez que resulten acreditados en su
                cuenta y conforme los plazos y mecanismos y reglas determinados por Yacaré. Sin perjuicio de lo
                anterior, eventualmente Yacaré, a través de las entidades financieras con las que opere, podrá ofrecer
                remuneración o intereses sobre los Fondos acreditados en la Cuenta, en cuyo caso las mismas se regirán
                conforme a los términos y condiciones especiales de dichas operatorias.
            </p>
            <p class="textBloque2">
                <b>10.6.</b> Pagos en Moneda Extranjera. Todos los pagos deberán ser realizados en moneda de curso legal
                de la República Argentina. El tipo de cambio que se tomará en consideración para la conversión de
                dólares estadounidenses a pesos será el tipo de cambio billete vendedor publicado al cierre del día
                anterior en el sitio web www.bna.com.ar u otro sitio web del Banco de la Nación Argentina.
            </p>
            <p class="textBloque2">
                <b>10.7. Políticas de privacidad.</b><br>
                Asumiendo el carácter de responsable inscripto, las políticas adoptadas por la App se encuentran en
                conformidad con lo dispuesto por la Ley de Protección de los Datos Personales N.º 25.326 y normas
                concordantes. El Usuario podrá acceder a la Políticas de Privacidad ingresando al sitio web del
                aplicativo: <a style="color: #FF6600;"
                    href="https://www.yacare.com/politica-de-proteccion-de-datos-personales/">
                    https://www.yacare.com/politica-de-proteccion-de-datos-personales/</a>
            </p>
            <p class="textBloque2">
                <b>10.8. Limitación de Responsabilidad por el Servicio y/o la Plataforma.</b><br>
                Yacaré no garantiza el acceso y uso continuado o ininterrumpido de su Sitio, del Servicio o de las
                Herramientas de Venta. El sistema puede eventualmente no estar disponible debido a dificultades técnicas
                o fallas de Internet en los links o Herramientas de Venta o por cualquier otra circunstancia ajena a
                Yacaré. Los Usuarios NO podrán imputarle responsabilidad alguna a Yacaré, ni exigir resarcimiento
                alguno, en virtud de perjuicios resultantes de las mencionadas dificultades, así como por cualquier otra
                clase de daños, incluyendo daños indirectos, especiales o consecuentes que surjan o experimenten los
                Usuarios, incluso en el caso que dichas fallas afecten los montos que deban ser pagados o acreditados.
                Asimismo, se aclara que los Servicios descriptos en el presente pueden estar parcialmente disponibles, o
                ser sus funcionalidades limitadas de acuerdo con los desarrollos que se vayan habilitando, y estas
                Condiciones Generales se aplicarán en la medida de tal disponibilidad.
            </p>
            <p class="textBloque2">
                <b>10.9. Licencia Limitada.</b><br>
                Todos los derechos intelectuales e industriales, sobre el Sitio, Herramientas de Venta, Códigos,
                desarrollo, software, hardware, dominio, logos, emblemas, logotipos, diseños, estructura, contenidos,
                información, etc. son de propiedad de Yacaré y/o sus sociedades controlantes, controladas, filiales o
                subsidiarias. En ningún caso se entenderá que el Usuario tendrá algún tipo de derecho sobre los mismos,
                independientemente de los derechos conferidos sobre las Herramientas de Venta que Yacaré pone a
                disposición del Vendedor durante la vigencia de estas Condiciones.
                Yacaré sólo autoriza al Vendedor a hacer uso de su propiedad intelectual, en lo referido a las
                Herramientas de Venta puestas a disposición del Vendedor, para el cumplimiento de las actividades que se
                derivan del presente Acuerdo, en su sitio Web haciendo relación directa al Servicio de Yacaré. Cualquier
                otra utilización de tal propiedad intelectual de Yacaré queda estrictamente prohibida. En la medida en
                que se cumpla con estas limitaciones, Yacaré otorga una licencia gratuita, no exclusiva y revocable al
                Vendedor.
            </p>
            <p class="textBloque2">
                <b>10.10. Cesión.</b><br>
                El Usuario no podrá ceder, transferir, delegar o disponer de los derechos u obligaciones derivados del
                presente Contrato, total o parcialmente. Yacaré podrá ceder, transferir, delegar o disponer de los
                derechos u obligaciones derivados del presente Contrato o de su posición contractual, total o
                parcialmente, aún de conformidad con los artículos 70 a 72 de la Ley N° 24.441, para lo cual el Usuario
                otorga su consentimiento de manera previa para la realización de dichas acciones.
            </p>
            <p class="textBloque2">
                <b>10.11. Documentación.</b><br>
                El Usuario opta expresamente que la documentación e información relacionada con las Condiciones
                Generales provista por Yacaré tenga, salvo disposición expresa en contrario, soporte electrónico. En
                todo caso, el Usuario podrá hacer copias, incluso en soporte físico, de la documentación e información
                provista por Yacaré relativa al Contrato. El Usuario autoriza en forma irrevocable a Yacaré y/o a quien
                Yacaré designe, a grabar las operaciones del Usuario relativas los servicios prestados por Yacaré, y a
                utilizar dichas grabaciones como medio probatorio ante autoridades administrativas y/o judiciales. Las
                constancias emitidas por Yacaré serán consideradas prueba suficiente del cumplimiento de las
                instrucciones y Solicitud de la Gestión de Pago, y sustituyen la necesidad de cualquier recibo y son
                plenamente oponibles al Usuario. A tales efectos, el Usuario y Yacaré acuerdan otorgarle valor
                probatorio a las constancias que se emitan como consecuencia de las aprobaciones o instrucciones dadas
                por el Usuario, con el alcance establecido en la legislación vigente.
            </p>
            <p class="textBloque2">
                <b>10.12. Embargos e inhabilitación de cuentas.</b><br>
                Yacaré, en su carácter de proveedor de servicios de pago, se encuentra facultado para trabar embargos y
                dar cumplimiento a cualquier medida ordenada por autoridad competente incluyendo sin limitación, la
                inhabilitación de la Cuenta en caso de quiebra.
            </p>
        </div>

        <div class="bloque">
            <div style="margin-bottom:30px">
                <span class="title-bloque2">
                    11. RESOLUCIÓN DE CONTROVERSIAS
                </span>
            </div>
            <p class="textBloque2">
                <b>11.1.</b> Los Usuarios aceptan someter sus controversias a la decisión de Yacaré conforme las reglas
                establecidas en este Términos y condiciones, según el caso y cuando los mismos resulten aplicables. Los
                Usuarios aceptan acatar la decisión que Yacaré determine cuando las partes de una operación sujeta a
                dicho mecanismo no lleguen a un acuerdo, y renuncian a realizar reclamo alguno contra Yacaré con motivo
                de dicha decisión. Yacaré solamente decidirá, en la solución de controversias cuando cuente con
                elementos que puedan justificar en forma suficiente y razonable dicha decisión, efectuándose dicha
                devolución se efectuará únicamente a la cuenta bancaria de origen de la que provinieron.
            </p>
            <p class="textBloque2">
                <b>11.2.</b> Las controversias de cualquier índole que se susciten entre los Usuarios y las
                Empresas/Comercios, por acción y/u omisión de alguno de ellos, respecto a la cantidad, calidad, precio,
                y/o cualquier otra característica o circunstancia de los bienes y servicios ofrecidos, deben ser
                resueltas exclusivamente entre ellos.
            </p>
            <p class="textBloque2">
                <b>11.3.</b> El Usuario que reciba Fondos en su Cuenta en pago de un bien o servicio (el “Usuario
                Destinatario”), por parte de otro usuario que haya pagado la compra o adquisición de dicho bien o
                servicio, sólo deberá enviar dicho bien o prestar dicho servicio a quien lo haya adquirido y pagado (el
                «Usuario Remitente») luego de verificar en su Cuenta, a través de la Plataforma de Yacaré, que los
                Fondos están debidamente acreditados. El Usuario Destinatario que envíe un bien sin verificar en su
                Cuenta que los Fondos han sido pagados por el Usuario Remitente y están acreditados, asumirá
                íntegramente el riesgo por la falta de pago del bien, liberando a Yacaré y a sus sociedades vinculadas
                de cualquier responsabilidad a este respecto.
                <br>Tanto el Usuario Remitente como el Usuario Destinatario deben ingresar a la Plataforma de Yacaré con
                su dirección de e-mail y Clave de seguridad personal a fin de verificar la efectiva transferencia de
                Fondos desde y/o la acreditación de Fondos en sus respectivas Cuentas.
            </p>
        </div>

        <div class="bloque">
            <div style="margin-bottom:30px">
                <span class="title-bloque2">
                    12. ACTUALIZACIONES DEL APLICATIVO MÓVIL
                </span>
            </div>
            <p class="textBloque2">
                Es posible que la App requiera actualizaciones, como correcciones de errores, mejoras de funciones,
                complementos faltantes y versiones nuevas (en conjunto, «Actualizaciones»). Al aceptar estos Términos y
                Condiciones y usar la App y/o su dominio web, el Usuario acepta recibir dichas Actualizaciones
                automáticamente en su Dispositivo Móvil.
            </p>
        </div>


        <div class="bloque">
            <div style="margin-bottom:30px">
                <span class="title-bloque2">
                    13. ACTUALIZACIONES DE LOS TÉRMINOS Y CONDICIONES
                </span>
            </div>
            <p class="textBloque2">
                <b>13.1.</b> El vínculo derivado de los presentes Términos y Condiciones se mantendrán vigentes por
                plazo indeterminado a partir del primer envío de e-mail que realice la App al Usuario, a través del
                cual, se notifica la confirmación de su registro/alta como Usuario del aplicativo móvil.
            </p>
            <p class="textBloque2">
                <b>13.2.</b> Yacaré se reserva el derecho de modificar estos Términos y Condiciones en cualquier
                momento, en
                forma temporal o definitiva, sin que estas medidas puedan ser objeto de requerimiento alguno, ni de
                derecho a reclamar daños o perjuicios por parte del Usuario. Las modificaciones serán comunicadas a
                través del Sitio web
                <a style="color: #FF6600;" href="https://www.yacare.com/">
                    https://www.yacare.com/</a>, o de medios de difusión masiva. Las modificaciones que se realicen de
                los Términos y Condiciones entrarán en vigor a los 30 (treinta) días a contar desde su publicación y/o
                notificación, salvo plazo menor por imposibilidad fundada.
            </p>
        </div>

        <div class="bloque">
            <div style="margin-bottom:30px">
                <span class="title-bloque2">
                    14. RESCISIÓN DEL SERVICIO
                </span>
            </div>
            <p class="textBloque2">
                Yacaré y el Usuario podrán en cualquier oportunidad de vigencia del presente Contrato terminarlo sin
                expresión de causa alguna, lo que implicará el cierre de la Cuenta del Usuario, pero no suspenderá el
                cumplimiento a todas las Solicitudes de Gestión de Pago ya autorizadas por el Usuario al momento de
                notificar la rescisión. A los efectos de ejercer esta facultad, es necesario que la parte que pretende
                la terminación del Contrato no adeude a la otra ni a terceros involucrados en las operaciones el
                cumplimiento de alguna obligación.
            </p>
            <p class="textBloque2">
                Asimismo, Yacaré podrá, en caso de incumplimiento del Usuario a las condiciones del presente Contrato o
                a la legislación aplicable en la materia, dar por terminada la prestación del Servicio sin ningún tipo
                de aviso previo, reservándose el derecho de reclamar los daños y perjuicios que tal incumplimiento le
                haya causado.
            </p>
        </div>

        <div class="bloque">
            <div style="margin-bottom:30px">
                <span class="title-bloque2">
                    15.NOTIFICACIONES, DOMICILIO CONSTITUIDO Y JURISDICCIÓN
                </span>
            </div>
            <p class="textBloque2">
                <b>15.1. Notificaciones.</b><br>
                Toda comunicación prevista a lo largo de las Condiciones Generales, incluyendo sin limitación, la
                modificación de estos documentos podrá efectuarse mediante avisos a través de circulares, notificaciones
                o notas y/o aclaraciones y/o colocando el texto de dicha comunicación en el Sitio y/o por correo
                electrónico a la dirección de mail declarada por el Usuario. Tales comunicaciones serán consideradas
                como integrantes de las presentes Condiciones generales. Las comunicaciones se presumen conocidas por
                los Usuarios desde la fecha de su puesta a disposición.
            </p>
            <p class="textBloque2">
                Así mismo, serán válidas y el Usuario acepta expresamente que todas las notificaciones realizadas a los
                Usuarios por Yacaré sean dirigidas (i) a la dirección de correo electrónico principal registrada por
                éstos (domicilio especial electrónico), y/o (ii) a la Cuenta del Usuario.
            </p>
            <p class="textBloque2">
                <b>15.2. Domicilio.</b><br>
                A todos los efectos emergentes de estos Términos, la Yacaré constituye domicilio en Av. Belgrano 312,
                Piso 1, Oficina 11,de la Ciudad Autónoma de Buenos Aires de la República Argentina.
            </p>
            <p class="textBloque2">
                <b>15.3. Jurisdicción.</b><br>
                Para la resolución de cualquier controversia, las Partes se someten a la jurisdicción delos tribunales
                ordinarios de los Tribunales Ordinarios con asiento en la Capital Federal o del domicilio real del
                Usuario denunciado a Yacaré al momento de la contratación, pudiendo en todos los casos el Usuario
                determinar esta última.
            </p>
        </div>

        <div class="bloque">
            <div style="margin-bottom:30px">
                <span class="title-bloque2">
                    16. ANEXOS
                </span>
            </div>
            <p class="textBloque2">
                <a style="color: #FF6600;" href="https://www.yacare.com/tarifas/">
                    Tarifa</a><br>
                <a style="color: #FF6600;" href="https://yacare.com/politica-de-proteccion-de-datos-personales/">
                    Política de Protección de Datos Personales.</a>

            </p>
            <p class="textBloqueLine">
                -----------------------------------------------------
            </p>
            <p class="textBloque2">
                El presente documento fue actualizado por última vez con fecha 30/09/2022
            </p>
            <p class="textBloque2">
                TÉRMINOS Y CONDICIONES PARTICULARES PARA USUARIOS DE YACARÉ AFILIADOS DE LA CAJA DE SEGURO MUTUAL DE LA
                PROVINCIA DE MENDOZA
            </p>
            <p class="textBloque2">
                Estos términos y condiciones de uso particulares (las “Condiciones Particulares”) para afiliados
                obligatorios y afiliados por continuidad a la Caja De Seguro Mutual, CUIT Nº 30-67980521-1 (la “CSM”)
                según se los define en los artículos 11 a 15 de la ley 9.121 de la Provincia de Mendoza(los “Afiliados”
                o “Usuarios”), usuarios de los productos o servicios(los “Productos y Servicios”) ofrecidos a través de
                terceros prestadores (los “Proveedores”) de la plataforma de servicios de pago denominada “Yacaré” de
                Orangedata S.A., CUIT 30-71239031-6 (“Yacaré”), o directamente por Yacaré son anexas, suplementan, y
                deben ser leídas, junto con las Condiciones Generales de Uso de Yacaré (las “Condiciones Generales”).
            </p>
            <p class="textBloque2">
                El Afiliado debe leer, entender y aceptar todas las condiciones establecidas en estas Condiciones
                Particulares y demás políticas y principios incorporados a las mismas por referencia, previo a su
                registro como Usuario de Yacaréperteneciente al grupo de afinidad de Afiliados a la CSM. En cualquier
                caso, la utilización del Servicio implica la aceptación por parte del usuario de estas Condiciones
                Particulares.
            </p>
            <p class="textBloque2">
                Cualquier Afiliado que no acepte estas Condiciones Particulares, los cuales tiene un carácter
                obligatorio y vinculante, deberá abstenerse de utilizar los Servicios dirigidos a estos.
            </p>
            <p class="textBloque2">
                <b>1. Oferta de Servicios</b>

            </p>
            <p class="textBloque2">
                Yacaré podrá poner a disposición de los Afiliados y en forma exclusiva, Productos y Servicios dirigidos
                en exclusiva al grupo de pertenencia de la CSM, tales como asistencias crediticias, tarjetas de
                beneficios, seguros, turismo u otros.
            </p>
            <p class="textBloque2">
                Los Productos y Servicios podrán ser provistos directamente por Yacaré y/o por terceros Proveedores.
            </p>
            <p class="textBloque2">
                <b>2. Cobranza de los Productos o Servicios</b>

            </p>
            <p class="textBloque2">
                La cobranza de los Productos y/o Servicios adquiridos por los Afiliados se efectuará a través del
                descuento de haberes de los Afiliados, mediante la utilización de los códigos de descuento de los que
                resulta titular la CSM. El descuento se realizará sobre los haberes del Afiliado por cualquier concepto
                (incluyendo sin limitación el pago de cualquier indemnización), aclarándose que de utilizarse esta
                modalidad el descuento será efectuado al momento de la liquidación del haber, y podrán realizarse
                descuentos parciales o segmentados relacionados con el vencimiento de las cuotas y demás montos
                (incluyendo sin limitación intereses, gastos, cargos, comisiones, e impuestos). Yacaré no es titular de
                los códigos de descuento y no realizará la cobranza de los mismos, la cual estará a cargo de la CSM en
                forma directa o indirecta a través de sus contratistas.
            </p>
            <p class="textBloque2">
                En el supuesto que los códigos de descuento por cualquier causa quedaren sin efecto o no se cobraren el
                precio o las cuotas de los Productos o Servicios, los Proveedores podrán libremente a su elección: a)
                Solicitar, por sí o a través de terceros, el descuento mediante el débito a través de la Clave Bancaria
                Uniforme – CBU del tomador, caja de ahorro o cuenta sueldo, o través de otros códigos de descuento de su
                titularidad o de terceros, b) efectuar la gestión de cobranza extrajudicial y/o judicial, en su caso,
                para el recupero de los importes adeudados por cada Usuario adquirente de un Producto. Las políticas de
                gestión de la mora y el recupero será realizada por cada Proveedor conforme a sus propias pautas.
            </p>
            <p class="textBloque2">
                En cualquier caso, la falta de pago por parte de los Afiliados de los Productos o Servicios contratados
                producirá la mora automática de estos y sin necesidad de notificación previa.
            </p>
            <p class="textBloque2">
                <b>3. Responsabilidad por los Servicios Ofrecidos</b>
            </p>
            <p class="textBloque2">
                Los precios y/o tasas de interés y/o cualquier contraprestación por los Productos o Servicios serán
                fijados oportunamente por cada Proveedor e informados en el momento de realizar cada operación a través
                de la plataforma Yacaré.
            </p>
            <p class="textBloque2">
                Conforme a lo antes expresado, el Proveedor será responsable exclusivo frente a los Usuarios y cualquier
                tercero por los Productos y/o Servicios prestados. La aceptación de los Productos o Servicios ofrecidos
                por el Proveedor y promocionados a través de la plataforma Yacaré, perfeccionará una transacción entre
                el Usuario y el Proveedor, del que Yacaré resulta ajena.
            </p>
            <p class="textBloque2">
                En dicho caso tanto el Proveedor como el Usuario habrán consentido celebrar un contrato sujetándose a
                dicho fin a las Condiciones Generales y estas Condiciones Particulares de utilización de la plataforma
                Yacaré. Ni Yacaré ni sus accionistas, directores, funcionarios o apoderados, serán responsables de los
                Productos o Servicios que no hayan sido provistos directamente por Yacaré, y su función se limitará a
                poner a disposición de los Proveedores y los Usuarios el acceso a Yacaré. Yacaré en ningún caso asumirá
                responsabilidad por la incorrecta prestación o defectos en los Productos o Servicios o reclamos de los
                Usuarios o terceros en relación a la contratación o adquisición de los mismos, ni de los Proveedores en
                relación a la falta de cumplimiento de las obligaciones de los Usuarios respecto de los Servicios o
                Productos adquiridos.
            </p>
            <p class="textBloque2">
                La cobranza de los Productos y Servicios mediante descuentos de sueldos de los Afiliados a través de los
                códigos de descuento de titularidad de la CSM, o por cualquier otro mecanismo previsto por los
                Proveedores, no será efectuada por Yacaré, sino por CSM y/o los Proveedores, por si o a través de
                agentes de cobro o terceros con los cuales hayan celebrado convenios. En este sentido, Yacaré no será
                responsable de cualquier cuestión vinculada con dicha cobranza, excepto exclusivamente en el caso de
                descuentos efectuados erróneamente y ordenados por Yacaré en relación a Productos o Servicios provistos
                directamente por Yacaré.
            </p>
            <p class="textBloque2">
                <b>4. Acuerdos Suplementarios. Interpretación</b>
            </p>
            <p class="textBloque2">
                <b>4.1</b> En caso de ser aceptadas las Condiciones Generales conforme a lo previsto en las mismas,
                estas condiciones Particulares serán asimismo aceptadas y formarán parte como Anexo del contrato
                existente entre el Usuario y Yacaré previsto en las Condiciones Generales oportunamente aceptadas por el
                Usuario. Las presentes Condiciones Particulares suplementan y deben ser leídas conjuntamente con dichas
                Condiciones Generales de Yacaré.
            </p>
            <p class="textBloque2">
                <b>4.2 </b> Las Condiciones Generales serán aplicables a los Afiliados junto con las Condiciones
                Particulares, excepto por aquellas cláusulas de las Condiciones Particulares que expresamente modifiquen
                las Condiciones Generales. En caso de divergencia entre las Condiciones Generales y las Condiciones
                Particulares, prevalecerán estas últimas.
            </p>
            <p class="textBloque2">
                El presente documento fue actualizado por última vez con fecha 30/09/2022
            </p>
        </div>


    </div>
</div>